<div class="d-flex mb-3 align-items-center">
  <span>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3 5.73957L8.30001 2.73957C8.20782 2.69376 8.10628 2.66992 8.00334 2.66992C7.9004 2.66992 7.79886 2.69376 7.70667 2.73957L3.70667 4.73957L1.70667 5.73957L1.04001 6.0729C0.930064 6.1283 0.837608 6.21306 0.772889 6.31779C0.708169 6.42252 0.673713 6.54312 0.67334 6.66623V10.6662H2.00667V7.07957L7.70667 9.9329C7.80001 9.97957 7.90001 10.0062 8.00667 10.0062C8.11334 10.0062 8.21334 9.97957 8.30667 9.9329L14.3067 6.9329C14.5333 6.81957 14.6733 6.58624 14.6733 6.33957C14.6733 6.0929 14.5333 5.85957 14.3067 5.74623L14.3 5.73957Z"
        fill="#969696" />
      <path
        d="M8.00016 11.3324C7.6935 11.3324 7.38016 11.2591 7.10683 11.1191L3.3335 9.23242V10.2924C3.3335 11.6658 5.4135 13.3324 8.00016 13.3324C10.5868 13.3324 12.6668 11.6724 12.6668 10.2924V9.23242L8.8935 11.1191C8.62016 11.2591 8.30683 11.3324 8.00016 11.3324Z"
        fill="#969696" />
    </svg>
  </span>
  <span class="f-12 font-weight-500 ml-2 text-black">
    Education
  </span>
</div>
@for(edu of education; track edu; let i = $index) {
   <div class="text-capitalize d-flex flex-column">
            <div class="d-flex">
               <!-- <div>
                  <div class="clogo mr-3">
                     <i class="fas fa-graduation-cap f-12"></i>
                  </div>
               </div> -->
               <div class="w-100">
                  <div>
                     <div style="line-height: 1" class="my-2">
                       <!-- [style.margin-top]="(!(edu.newField ? edu.newField : edu.degrees.toString())) ? '15px' : null" -->
                        <div class="text-black font-weight-500 f-12">
                          @if(edu && edu.school && edu.school.name) {
                          <span>{{edu.school.name | titlecase}}</span>
                          }

                        </div>
                        <div class="d-flex text-9696 f-12 mb-1">
                          @if(edu.newField || edu.degrees.toString()) {
                          <span>
                             {{edu.newField ? edu.newField : edu.degrees.toString() }}

                          </span>
                        }
                         @if( (edu.newField || edu.degrees.toString()) && edu?.start_date){
                        <span>
                            <i class="fas fa-circle f-12 mx-1" style="font-size: 3px; margin-top: 0px;" aria-hidden="true"></i>
                        </span>
                      }
                        @if(edu?.start_date){
                          <span>

                            {{formatDate(edu.start_date)}} - {{edu.end_date != null ? formatDate(edu.end_date) : 'Current'}}
                          </span>
                           }
                        </div>
                      </div>
                  </div>
               </div>
            </div>
            @if(i != education?.length - 1) {
            <hr style="color: #d5dee6; width: 100%; text-align: center; height: 1px;" class="my-0" >

            }
        </div>
      }
